import Utils from 'js/3d/lib/util'

// Base class for control modes. Handles the switching on
// and off of the control mode and calling activation
// callbacks.
class ControlMode {
  constructor(controls, active) {
    this.activate = this.activate.bind(this)
    this.deactivate = this.deactivate.bind(this)
    this.controls = controls
    if (active == null) {
      active = false
    }
    this.active = active
    this.init()
    if (active) {
      Utils.defer(this.activate)
    }
    this.controls.addEventListener('tick', dt => {
      if (this.active) {
        return this.tick(dt)
      }
    })
  }

  activate() {
    if (!this.active) {
      this.active = true
      this.onActivate()
    }
  }

  deactivate() {
    if (this.active) {
      this.active = false
      this.onDeactivate()
    }
  }

  // Lifetime methods and events
  init() {
    return 'Called when subclasses are created to avoid super()'
  }
  /**
   * Called every frame when control mode is activated
   * @param dt Delay time in ms?
   */
  tick() {
    return 'Called every frame if the mode is active'
  }
  onActivate() {
    return 'Called when the control mode is activated'
  }
  onDeactivate() {
    return 'Called when the control mode is deactivated'
  }
}

export default ControlMode
